import { Progress, parseUtc } from "../lifecycle/api";

export type ChecklistStepId = "setup" | "first_edge" | "closing_line";

export interface ChecklistState {
  done: Record<ChecklistStepId, boolean>;
  completed: number;
  /** The step to work on next, or null once all three are done. */
  current: ChecklistStepId | null;
}

const ORDER: ChecklistStepId[] = ["setup", "first_edge", "closing_line"];

export function checklistState(
  progress: Progress,
  bankroll: number | null | undefined,
): ChecklistState {
  const activated = Boolean(progress.activated_at);
  const done: Record<ChecklistStepId, boolean> = {
    // A closing line result proves the earlier steps happened, even for
    // accounts tracked before the checklist existed.
    setup: activated || (Boolean(progress.configured_at) && (bankroll ?? 0) > 0),
    first_edge: activated || Boolean(progress.first_value_at),
    closing_line: activated,
  };
  return {
    done,
    completed: ORDER.filter((id) => done[id]).length,
    current: ORDER.find((id) => !done[id]) ?? null,
  };
}

/** The first session belongs to people with a live subscription. */
export function showsChecklist(progress: Progress | null): progress is Progress {
  return (
    progress != null &&
    ["trialing", "active"].includes(progress.billing_status ?? "")
  );
}

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Done for over a week, so "your first week" no longer describes them. A return
 * restarts the checklist, and that restart does not count as done yet.
 */
export function checklistIsOld(progress: Progress, now: number = Date.now()): boolean {
  const activated = parseUtc(progress.activated_at);
  if (!activated || now - activated.getTime() <= WEEK_MS) return false;
  const returned = parseUtc(progress.returned_at);
  return !returned || returned.getTime() < activated.getTime();
}

/** Measured on the record's own new edges over the 30 days to 10-31-2026. */
export const NEW_PRICES_LINE =
  "New prices usually land around noon to 2 PM ET and again around 8 PM ET.";
